var _path, _path2, _path3, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6309 33C26.1913 33 33.1309 26.0604 33.1309 17.5C33.1309 8.93959 26.1913 2 17.6309 2C9.07045 2 2.13086 8.93959 2.13086 17.5C2.13086 26.0604 9.07045 33 17.6309 33Z",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2676 13.625C10.2676 13.1111 10.4717 12.6183 10.8351 12.255C11.1984 11.8916 11.6912 11.6875 12.2051 11.6875C12.7189 11.6875 13.2117 11.8916 13.5751 12.255C13.9384 12.6183 14.1426 13.1111 14.1426 13.625",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8926 13.625C21.8926 13.3706 21.9427 13.1186 22.0401 12.8836C22.1374 12.6485 22.2801 12.4349 22.4601 12.255C22.64 12.0751 22.8536 11.9324 23.0886 11.835C23.3237 11.7376 23.5756 11.6875 23.8301 11.6875C24.0845 11.6875 24.3365 11.7376 24.5715 11.835C24.8066 11.9324 25.0202 12.0751 25.2001 12.255C25.38 12.4349 25.5227 12.6485 25.6201 12.8836C25.7175 13.1186 25.7676 13.3706 25.7676 13.625",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.35,
    y1: 22.65,
    x2: 23.65,
    y2: 22.65,
    stroke: "#838990",
    strokeWidth: 2.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.cfed2a156747c9f297661496c21a68fe.svg";
export { ForwardRef as ReactComponent };